import React from 'react'
import { ImportContainerDetail } from '../../types/container'
import { Modal } from '../ui/Modal/Modal'
import { ModalHeader } from '../ui/Modal/ModalHeader'
import { ModalBody } from '../ui/Modal/ModalBody'
import { Table } from '../ui/Table/Table'
import { TableHeader } from '../ui/Table/TableHeader'
import { TableRow } from '../ui/Table/TableRow'
import { TableCell } from '../ui/Table/TableCell'

export interface ImportDetailModalProps {
  detail: ImportContainerDetail | null
  isOpen: boolean
  onClose: () => void
}

export const ImportDetailModal: React.FC<ImportDetailModalProps> = ({ detail, isOpen, onClose }) => {
  if (!detail) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-6xl">
      <ModalHeader
        title={`Import: ${detail.containerNumber}`}
        onClose={onClose}
      />
      <ModalBody>
        <Table>
          <TableHeader columns={6}>
            <TableCell>Laad/los locatie</TableCell>
            <TableCell>Datum</TableCell>
            <TableCell>Uur</TableCell>
            <TableCell>Kaai</TableCell>
            <TableCell>Referentie</TableCell>
            <TableCell>Klantcode</TableCell>
          </TableHeader>

          <TableRow columns={6}>
            <TableCell>{detail.laadLosLocatie}</TableCell>
            <TableCell>{detail.datum}</TableCell>
            <TableCell>{detail.uur}</TableCell>
            <TableCell>{detail.kaai}</TableCell>
            <TableCell>{detail.referentie}</TableCell>
            <TableCell>{detail.klantcode}</TableCell>
          </TableRow>
        </Table>
      </ModalBody>
    </Modal>
  )
}
